import React, { useState } from 'react';
import { makeStyles, CssBaseline, Button, Grid } from '@material-ui/core';
import Banner from '../components/Banner.js';
import RoomCard from '../components/RoomCard.js';
import DatePicker from '../components/DatePicker.js';
import mockData from '../mockData.js';

const Home = () => {
	const classes = useStyles();
	const [showdates, setShowdates] = useState(false);

	return (
		<>
			<CssBaseline />
			<div className={classes.root}>
				<div className={classes.dates}>
					<Button onClick={() => setShowdates(!showdates)}>
						{showdates ? "Hide" : "Search Dates"}
					</Button>
				</div>
				{showdates && <DatePicker />}
				<Banner />
				<Grid container className={classes.section} spacing={3}>
					{mockData.map(({ src, title, description }) => (
						<Grid item sm={12} md={6} lg={4}>
							<RoomCard
								src={src}
								title={title}
								description={description}
								key={title}
							/>
						</Grid>
					))}
				</Grid>
			</div>
		</>
	);
};

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexDirection: "column",
		margin: theme.spacing(0,2,1,2),
	}, 
	dates: {
		display: "flex",
		flexDirection: "column",
		"& button" : {
			border: "1px solid #ccc",
			backgroundColor: "rgba(255,120,31,.6)",
			color: "#fefefe",
			padding: theme.spacing(2),
			fontWeight: "bold",
		}, 
		"& button:hover" : {
			color: "rgba(255,120,31,.8)",
			backgroundColor: "#fefefe",
		}
	},
}));


export default Home